<div>
  <h4 nz-typography>הערות</h4>
  <nz-list
    *ngIf="notes && notes.length"
    [nzDataSource]="notes"
    [nzRenderItem]="item"
    [nzItemLayout]="'horizontal'"
  >
    <ng-template #item let-item>
      <nz-comment
        [nzAuthor]="item.user.displayName"
        [nzDatetime]="item.createdAt | date: 'medium'"
      >
        <nz-avatar
          nz-comment-avatar
          nzIcon="user"
          [nzSrc]="item.user.avatar"
        ></nz-avatar>
        <nz-comment-content>
          <p [class.deleted]="item.deletedAt">{{ item.content }}</p>
        </nz-comment-content>
        <nz-comment-action>
          <span (click)="deleteNote(item.id)" *ngIf="canDelete(item)">
            מחק
          </span>
        </nz-comment-action>
      </nz-comment>
    </ng-template>
  </nz-list>
  <nz-comment *ngIf="!readonly">
    <nz-avatar
      nz-comment-avatar
      nzIcon="user"
      [nzSrc]="user.avatar"
    ></nz-avatar>
    <nz-comment-content>
      <nz-form-item>
        <textarea [(ngModel)]="inputValue" nz-input rows="4"></textarea>
      </nz-form-item>
      <nz-form-item>
        <button
          nz-button
          nzType="primary"
          [nzLoading]="processing"
          [disabled]="!inputValue"
          (click)="addNote()"
        >
          הוסף הערה
        </button>
      </nz-form-item>
    </nz-comment-content>
  </nz-comment>
</div>
